// extracted by mini-css-extract-plugin
export default {"msg_container":"sba","message":"tba","show":"uba","fromRD":"vba","fromCustomer":"wba","note":"xba","loading":"yba","image":"zba","initials":"Aba","input_wrapper":"Bba","input":"Cba"};
    if(module.hot) {
      // 1714654900395
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  